import { Box, Text, Tag, TagLabel, TagLeftIcon, useTheme } from '@vitvio/design-system';
import { graphql, useFragment } from 'react-relay';
import type { ORConsoleDetailHeaderFragment$key } from './__generated__/ORConsoleDetailHeaderFragment.graphql';
import { FormattedDate } from '@vitvio/time-components';
import { FaUser } from 'react-icons/fa6';

const observerViewDetailHeaderFragment = graphql`
  fragment ORConsoleDetailHeaderFragment on Surgery {
    name
    patientMrn
    plannedStart
  }
`;

interface ORConsoleDetailHeaderProps {
  detailHeaderFragmentRef: ORConsoleDetailHeaderFragment$key | undefined;
}

export function ORConsoleDetailHeader({ detailHeaderFragmentRef }: ORConsoleDetailHeaderProps) {
  const data = useFragment(observerViewDetailHeaderFragment, detailHeaderFragmentRef);
  const { getColor, getSpacing } = useTheme();

  return (
    <Box borderBottom={'solid 1px'} borderColor={getColor('border')}>
      <Box p={'var(--chakra-space-4)'}>
        <Box display="flex">
          <Text paddingRight={10} font="headings.M_SemiBold">
            {data?.name}
          </Text>
          <Tag variant="subtle" colorScheme="gray" h={'24px'}>
            <TagLeftIcon boxSize="12px" as={FaUser} color={getColor('fg.accent')} />
            <TagLabel>MRN {data?.patientMrn}</TagLabel>
          </Tag>
        </Box>
        <Box>
          <Text color={getColor('fg.muted')} fontSize={'14'} paddingTop={getSpacing('2')} fontWeight={'medium'}>
            <FormattedDate dateString={data?.plannedStart} />
          </Text>
        </Box>
      </Box>
    </Box>
  );
}
